<div class="multimedia_wrapper">
  <h4 *ngIf="headline">{{ headline }}</h4>
  <div
    *ngFor="let MultimediaItem of MultimediaItems"
    class="multimedia_content"
  >
    <h4 *ngIf="MultimediaItem.name">{{ MultimediaItem.headline }}</h4>
    <div class="multimedia_item">
      <span>
        <hdi-icon
          class="icon"
          [color]="IconBlack"
          [iconName]="IconPDF"
        ></hdi-icon>
        <p>{{ MultimediaItem.name }}</p>
      </span>
      <a class="icon download" href=" {{ MultimediaItem.link }} ">
        <hdi-icon [color]="IconBlack" [iconName]="iconDownload"></hdi-icon>
      </a>
    </div>
  </div>
</div>
